import cloneDeep from 'lodash/cloneDeep';

const getTourMode = ({
    isCommunity,
    floorPlanIndex = null,
    unitIndex = null,
}) => {
    let mode = isCommunity ? 'amenity' : 'singleFamily';

    if (floorPlanIndex !== null) {
        mode = 'floorplan';
    }
    if (unitIndex !== null) {
        mode = 'unit';
    }
    return mode;
};

const getModelId = ({
    floorPlanIndex = null,
    unitIndex = null,
    formData: { floorplans, units },
}) => {
    const floorPlan = floorPlanIndex !== null && floorplans[floorPlanIndex];
    // Unit tour without floor plan
    if (floorPlanIndex === null && unitIndex !== null) {
        return units[unitIndex].unitId;
    }

    // Unit tour with floor plan
    if (floorPlanIndex !== null && unitIndex !== null) {
        const unit = floorPlan && floorPlan.units[unitIndex];
        return unit ? unit.unitId : null;
    }
    return floorPlan ? floorPlan.floorPlanId : null;
};

const updateTour = ({
    floorPlanIndex = null,
    formData: { units, floorplans },
    tourToUpdate,
    unitIndex = null,
    updateFormData,
}) => {
    // Unit tour without floor plan
    if (floorPlanIndex === null && unitIndex !== null) {
        const newUnits = cloneDeep(units);
        newUnits[unitIndex].tour = tourToUpdate;
        updateFormData({ units: newUnits });
    } else if (floorPlanIndex !== null) {
        const newFloorplans = cloneDeep(floorplans);

        // Unit tour with floor plan
        if (unitIndex !== null) {
            newFloorplans[floorPlanIndex].units[unitIndex].tour = tourToUpdate;
        // Floor plan tour
        } else {
            newFloorplans[floorPlanIndex].tour = tourToUpdate;
        }
        updateFormData({ floorplans: newFloorplans });
    } else {
        updateFormData({ tour: tourToUpdate });
    }
};

const getAssociatedTourId = ({
    floorPlanIndex = null,
    unitIndex = null,
    formData,
}) => {
    const { floorplans, units } = formData;
    const floorPlan = floorPlanIndex && floorplans[floorPlanIndex];

    // Unit tour without floor plan
    if (floorPlanIndex === null && unitIndex !== null) {
        return units[unitIndex].tour.id || null;
    }

    // Unit tour with floor plan
    if (floorPlanIndex !== null && unitIndex !== null) {
        const unit = floorPlan && floorPlan.units[unitIndex];
        return unit ? (unit.tour.id || null) : null;
    }

    // Floor plan tour
    if (floorPlanIndex !== null) {
        return floorPlan ? (floorPlan.tour.id || null) : null;
    }

    // Listing tour
    return formData.tour.id || null;
};

export {
    getAssociatedTourId,
    getModelId,
    getTourMode,
    updateTour,
};
